import * as React from "react";

function SvgSquareModern(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}><path d="M20.8 44.5H0V23.7L9.3 5.5h7.3L12 23.7h8.8v20.8zm29.2 0H29.2V23.7l9.3-18.1h7.3l-4.6 18.1H50v20.8z" /></svg>;
}

export default SvgSquareModern;